import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetDashboardViewAndProjectSpocsRPC } from "./getDashboardViewAndProjectSpocsRPC";

export class GetDashboardViewAndProjectSpocsRPCClientImpl extends GetDashboardViewAndProjectSpocsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetDashboardViewAndProjectSpocsRPC.Request): Promise<LeoRPCResult<GetDashboardViewAndProjectSpocsRPC.Response, GetDashboardViewAndProjectSpocsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/GetDashboardViewAndProjectSpocs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetDashboardViewAndProjectSpocsRPC.ResponseDTO,
      GetDashboardViewAndProjectSpocsRPC.Errors.ErrorsDTO,
      GetDashboardViewAndProjectSpocsRPC.Response,
      GetDashboardViewAndProjectSpocsRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/GetDashboardViewAndProjectSpocs",
      GetDashboardViewAndProjectSpocsRPC.Response.fromDTO,
      GetDashboardViewAndProjectSpocsRPC.Errors.fromDTO
    );
  }
}
